// extracted by mini-css-extract-plugin
export default {"tabChildContainer":"MediaTab_tabChildContainer__f1g-a","attachments":"MediaTab_attachments__neTeV","attachmentItems":"MediaTab_attachmentItems__pUl6n"};